import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import { Button, Stack } from 'common/components/material';
import React from 'react';
import { VoteType } from '../matching-engine.utils';
import ColorPalette from 'common/theme/colorPalette';

export const UpvoteButton: React.FC<{
  isSelected: boolean;
  isDisabled?: boolean;
  onClick?: () => void;
}> = ({ isSelected, isDisabled = false, onClick }) => {
  const green = ColorPalette.GREEN400;
  const greenDark = ColorPalette.GREEN500;

  const Icon = isSelected ? ThumbUpAltIcon : ThumbUpOffAltIcon;

  return (
    <Button
      disabled={isDisabled}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
      disableRipple
      sx={{
        minWidth: 0,
        width: 32,
        height: 32,
        padding: 0,
        borderRadius: '50%',

        border: `1.5px solid ${green}`,
        color: isSelected ? 'white' : green,
        backgroundColor: isSelected ? green : 'transparent',

        '&:hover': {
          backgroundColor: isSelected ? greenDark : 'rgba(110,232,122,0.1)',
        },
      }}
    >
      <Icon fontSize="small" />
    </Button>
  );
};

export const DownvoteButton: React.FC<{
  isSelected: boolean;
  isDisabled?: boolean;
  onClick?: () => void;
}> = ({ isSelected, isDisabled = false, onClick }) => {
  const red = ColorPalette.RED400;
  const redDark = ColorPalette.RED500;

  return (
    <Button
      disabled={isDisabled}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
      disableRipple
      sx={{
        minWidth: 0,
        width: 32,
        height: 32,
        padding: 0,
        borderRadius: '50%',
        transition: 'all 0.2s',

        border: `1.5px solid ${red}`,
        color: isSelected ? 'white' : red,
        backgroundColor: isSelected ? red : 'transparent',

        '&:hover': {
          backgroundColor: isSelected ? redDark : 'rgba(248,113,113,0.1)',
        },
      }}
    >
      <ThumbDownOffAltIcon fontSize="small" />
    </Button>
  );
};

export const SkillEndorsementButtons: React.FC<{
  value: VoteType | null;
  onSelect?: (value: VoteType | null) => void;
  isDisabled?: boolean;
  handleSubmit?: () => void;
}> = ({ value, onSelect, isDisabled, handleSubmit }) => {
  return (
    <Stack direction="row" spacing={1}>
      <UpvoteButton
        isSelected={!isDisabled && value === VoteType.UPVOTE}
        onClick={
          isDisabled
            ? undefined
            : () => {
                onSelect?.(VoteType.UPVOTE);
                handleSubmit && handleSubmit();
              }
        }
        isDisabled={isDisabled}
      />
      <DownvoteButton
        isSelected={!isDisabled && value === VoteType.DOWNVOTE}
        onClick={
          isDisabled
            ? undefined
            : () => {
                onSelect?.(VoteType.DOWNVOTE);
                handleSubmit && handleSubmit();
              }
        }
        isDisabled={isDisabled}
      />
    </Stack>
  );
};
